import { IApiMainScore, IApiScoreResult, IScore } from './score.types';

export const scoreSerializer = (apiScore: IApiScoreResult): IScore => ({
  againstAboid: apiScore.data.attributes.score.againstAboid.toString(),
  score: apiScore.data.attributes.score.score,
  personalityScore: apiScore.data.attributes.score.personalityScore,
  valueScore: apiScore.data.attributes.score.valueScore,
  visionScore: apiScore.data.attributes.score.visionScore,
});

export const mainScoreSerializer = (score: IApiMainScore) => ({
  score: score.attributes.score,
});
